import { NProductConfiguration } from '@df/module-product-configuration/df-module-product-configuration.interfaces';
import { ProductConfiguration } from '@df/module-product-configuration/model/product-configuration';
import { Nexus } from '@tomandco/nexus-api-types';
import { TCustomOption } from '../product-configuration-configurable-product-data.service';

export abstract class Option<TData> {
    protected _value: TData | undefined;

    abstract type: string;

    get value(): TData | undefined {
        return this._value;
    }

    set value(value: TData | undefined) {
        if (this._value !== value) {
            this._value = value;
            this.sanitize();
            this.configuration.customOptionsDataChange$.next(this as TCustomOption);
        }
    }

    constructor(
        private configuration: ProductConfiguration,
        readonly data: Nexus.Lib.Catalog.Type.IProductDataCustomOption
    ) {}

    toRequest(): { key: number; value: TData } | undefined {
        if (this.value) {
            return {
                key: this.data.id,
                value: this.value
            };
        }
    }

    protected sanitizeValue(value: TData | undefined): TData | undefined {
        return value;
    }

    sanitize() {
        if (typeof this._value === 'string') {
            this._value = this._value.trim() as TData;
        }
    }

    validate(): NProductConfiguration.Error.Entry | undefined {
        if (this.data.req && !this.value) {
            return {
                code: NProductConfiguration.Error.Code.missing,
                level: NProductConfiguration.Error.Level.error,
                fieldName: this.data.title
            };
        }

        if (this.data.max && typeof this._value === 'string' && this._value.length > this.data.max) {
            return {
                code: NProductConfiguration.Error.Code.invalid,
                level: NProductConfiguration.Error.Level.error,
                fieldName: this.data.title
            };
        }
    }
}
